<template>
  <div class="wrapper">
    <div class="LicenseUpload">
      <!-- 左半部分 -->
      <div class="left-LicenseUpload">
        <div class="">
          <div class="title">
            企业名称：
          </div>
          <div class="context">
            {{WarnInfoData.BLCompanyName}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            统一社会信用代码：
          </div>
          <div class="context">
            {{WarnInfoData.BLUnifiedSocialCreditCode}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            法定代表人：
          </div>
          <div class="context">
            {{WarnInfoData.BLLegalRepresentative}}
          </div>
        </div>

        <div class="border-context">
          <div class="title">
            起始时间：
          </div>
          <div class="context">
            {{WarnInfoData.BLBusinessStartDate}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            注册资本：
          </div>
          <div class="context">
            {{WarnInfoData.BLRegisteredCapital}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            住所：
          </div>
          <div class="context">
            {{WarnInfoData.BLAddress}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            营业执照
          </div>
          <!-- <div class="context"> -->
          <div class="LookImgUpload">
            <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title="" :BLPhotoURL="WarnInfoData.BLPhotoURL" ></CommonuploadEnclosure>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <!--右半部分-->
      <div class="right-LicenseUpload">
        <div class="">
          <div class="title">
            企业类型：
          </div>
          <div class="context">
            {{WarnInfoData.BLCompanyType}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            证照编号：
          </div>
          <div class="context">
            {{WarnInfoData.BLLicenceCode}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            经营范围：
          </div>
          <div class="context">
            {{WarnInfoData.BLBusinessScope}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            失效时间：
          </div>
          <div class="context">
            {{WarnInfoData.BLBusinessEndDate}}
          </div>
        </div>
        <div class="border-context">
          <div class="title">
            成立时间：
          </div>
          <div class="context">
            {{WarnInfoData.BLEstablishmentDate}}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
      type: undefined
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>